import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { customThemeModel } from '../../models';

export const styles = makeStyles((theme: Theme & customThemeModel) =>
  createStyles({
    dropdownWrapper: {
      position: 'relative'
    },
    dropdownLabel: {
      marginBottom: 6,
      color: theme.colors.text,
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 15,
      lineHeight: '16px'
    },
    distantLabel: {
      marginBottom: 16
    },
    dropdownSelect: {
      minWidth: theme.lengths.minInputWidth,
      maxWidth: theme.lengths.maxInputWidth,
      height: theme.lengths.elementsHeight,
      color: theme.colors.text,
      backgroundColor: theme.colors.white,
      borderRadius: 8,
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 14,
      lineHeight: '20px',
      '& .MuiSelect-icon': {
        margin: '9px 5px 0 0'
      },
      '& .MuiSelect-root': {
        '& > svg': {
          display: 'none'
        }
      },
      '& .MuiOutlinedInput-input': {
        padding: '8px'
      }
    },
    dropdownMenu: {
      marginTop: 31,
      '& .MuiPaper-root': {
        marginTop: 8,
        minHeight: 40,
        maxWidth: 350,
        maxHeight: 300,
        backgroundColor: theme.colors.white,
        border: `1px solid ${theme.colors.primary}`,
        borderRadius: 8
      },
      '& .MuiList-root': {
        padding: '2px 0'
      },
      '& .Mui-selected': {
        backgroundColor: 'rgba(237, 243, 248, 0.5)'
      },
      '& .Mui-selected:hover': {
        backgroundColor: 'rgba(237, 243, 248, 0.5)'
      },
      '& .MuiMenuItem-root:hover': {
        backgroundColor: 'rgba(237, 243, 248, 0.5)'
      }
    },
    fullWidth: {
      width: '100%'
    },
    border: {
      '& .MuiOutlinedInput-notchedOutline': {
        border: '1px solid rgba(0, 83, 154, 0.5)'
      }
    },
    greyBorder: {
      '& .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.colors.greyBorder}`
      }
    },
    shortInput: {
      minWidth: '123px !important',
      width: '123px !important'
    },
    longInput: {
      maxWidth: '567px !important',
      width: '567px !important'
    },
    placeholder: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
      color: 'rgba(51, 51, 51, 0.5)'
    },
    fullWidthContainer: {
      '& .MuiPopover-paper': { maxWidth: 'unset', paddingBottom: '8px' }
    },
    formControlError: {
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: `${theme.colors.error} !important`
        },
        '&:hover fieldset': {
          borderColor: `${theme.colors.error} !important`
        },
        '&.Mui-focused fieldset': {
          borderColor: `${theme.colors.error} !important`
        }
      }
    },
    errorText: {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      minWidth: 135,
      color: theme.colors.error,
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px'
    },
    warningLogo: {
      marginRight: '4.5px'
    }
  })
);
